import React from 'react';
import { Tooltip } from 'antd';
import { MoonStar, ChessQueen, ChessKing, Crown, ChessKnight, ChessPawn, ChessRook } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import "./style/level.css";
interface UserLevelProps {
    level?: number,
    hasIcon?: boolean,
    isDarkMode?: boolean
    size?: 'xs' | 'sm' | 'md'
    className?: string
    bgColor?: string
}
export default function UserLevel({
    level = 1,
    hasIcon = true,
    isDarkMode = false,
    size = 'sm',
    className = '',
    bgColor = 'bg-background-3/10',
}: UserLevelProps) {
    const { t } = useTranslation();
    const sizeClass = size === 'xs' ? 'size-2' : size === 'sm' ? 'size-2.5' : 'size-3';
    // 切割等级，每10级位一个等级
    const levelIndex = Math.ceil(level / 10);
    const isFullLevel = level === 60;
    const renderIcon = () => {
        if (level <= 10) {
            return <MoonStar className={sizeClass} fill='currentColor' />
        }
        if (level <= 20) {
            return <ChessRook className={sizeClass} />
        }
        if (level <= 30) {
            return <ChessPawn className={sizeClass} />
        }
        if (level <= 40) {
            return <ChessKnight className={sizeClass} />
        }
        if (level <= 50) {
            return <ChessKing className={sizeClass} />
        }
        if (level < 60) {
            return <Crown className={sizeClass} />
        }
        return <ChessQueen className={sizeClass} />;
    }

    const classNames = `co-number-bold level-tag ${isDarkMode ? 'level-tag-dark' : ''} level-tag-${size} level-tag-${levelIndex} ${isFullLevel ? 'level-tag-full' : ''} ${className}`;

    return (
        <Tooltip title={`${t('Me.personal.membershipTier')}: LV.${level}`}>
            <div className={classNames}>
                <div className='absolute top-0 left-0 w-full h-full rounded-full z-[1] bg-background-card'></div>
                <div className={`absolute top-0 left-0 w-full h-full rounded-full z-[2] ${bgColor}`}></div>
                <div className='level-tag-main'>
                    {hasIcon && renderIcon()}
                    LV.{level}
                </div>
            </div>
        </Tooltip>
    )

}
